module.exports = "<div class=\"ModalHeader\">\r\n  <!--<div class=\"close-icon\"></div>-->\r\n  <span>{{header}}</span>\r\n  <!--<div\r\n    class=\"close-icon\"\r\n    title=\"{{::('default.close.label' | translate)}}\"\r\n    ng-click=\"close()\">\r\n\r\n    <i class=\"icon ion-close\"></i>\r\n  </div>-->\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/core-components-implementation/modals/modal-close-header.html
// module id = 2959
// module chunks = 0